const Actions = require('../actions/')
const ListItem = require ('../list-item/')

class FormField {
  constructor(document) {
    document = document || {}
    this.title = document.title || ''
    this.domainType = document.domainType || 0
    this.listItem = (document.listItem && document.listItem.length) ? document.listItem.map(i => new ListItem(i)) : []
    this.isClientVisible = new Actions(document.isClientVisible)
    this.isClientEditable = new Actions(document.isClientEditable)
    this.isMandatory = new Actions(document.isMandatory)
    this.isPredefinedContent = new Actions(document.isPredefinedContent)
    this.alphabeticallyOrdered = document.alphabeticallyOrdered || false
    this.fieldId = document.fieldId || ''
    this.description = document.description || ''
    this.fieldType = document.fieldType || 0
    this.nameFieldType = document.nameFieldType || ''
  }
}

module.exports = FormField
